import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-activity-drawer',
    templateUrl: './activity-drawer.component.html',
    standalone: false
})
export class ActivityDrawerComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
